import styled from 'styled-components'

export const Section = styled.section`
    padding-top: 90px;
    padding-bottom: 120px;

    @media screen and (max-width: 767px) {
        padding-top: 60px;
        padding-bottom: 80px;
    }
`



// WEBPACK FOOTER //
// ./src/shared/helpers.js